import React from 'react';
import { Link } from 'react-router-dom';
import SEO from './SEO';

const NotFound = () => {
  return (
    <>
      <SEO
        title="Page Not Found (404)"
        description="The page you are looking for could not be found. Explore thesis writing, paper writing and research paper publication services by Assurance Education Group in Bhopal."
        canonicalPath="/404"
        noindex
      />
      <main className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-6 text-center">
        <p className="text-6xl font-extrabold text-blue-800">404</p>
        <h1 className="mt-4 text-2xl font-bold text-gray-900">
          This page could not be found
        </h1>
        <p className="mt-3 max-w-md text-gray-600">
          The link may be broken or the page may have been moved. Explore our
          thesis writing, paper writing and research paper publication services
          instead.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-4">
          <Link
            to="/"
            className="rounded-lg bg-blue-700 px-5 py-2.5 text-white transition-colors hover:bg-blue-800"
          >
            Back to Home
          </Link>
          <Link
            to="/thesis-home"
            className="rounded-lg border border-blue-700 px-5 py-2.5 text-blue-700 transition-colors hover:bg-blue-50"
          >
            Thesis Writing Services
          </Link>
        </div>
      </main>
    </>
  );
};

export default NotFound;
